import { Component, Input } from '@angular/core';
import { SubscribedContainer } from 'app/shared/util/subscribed-container';
import { ITransporterMember } from '../../../../../../models/transporter-member.model';

type ITransporterMemberInEdit = ITransporterMember & {
  picturePreview?: string;
};

@Component({
  selector: 'jhi-team-contact-card-visual',
  templateUrl: './team-contact-card-visual.component.html',
  styleUrls: ['./team-contact-card-visual.component.scss'],
})
export class TeamContactCardVisualComponent extends SubscribedContainer {
  @Input() transporterMember?: ITransporterMemberInEdit;
  @Input() existingVisual?: string;

  public getStyle(): string | undefined {
    const backgroundImage = this.getPicture();
    return backgroundImage ? 'background-image: url("' + backgroundImage + '");' : undefined;
  }

  public getPicture(): string | undefined {
    if (this.transporterMember?.picture && this.existingVisual && !this.transporterMember.picturePreview) {
      return this.existingVisual;
    } else if (this.transporterMember?.picturePreview) {
      return this.transporterMember.picturePreview;
    }
    return undefined;
  }
}
